"use client";

import { BlogCard } from "@/components/molecules/BlogCard";
import type { GetBlogOverviewQuery } from "@/graphql/sdk/__generated__";
import { cn } from "@/helpers/className";
import { useTranslation } from "@/i18n/client";
import type { AllowedLanguages } from "@/types/generic";

interface BlogListProps {
  className?: string;
  locale: AllowedLanguages;
  results: NonNullable<GetBlogOverviewQuery["blogOverviewGraphql"]>["results"];
}

export const BlogList = ({ results, locale, className }: BlogListProps) => {
  const { t } = useTranslation(locale);
  return (
    <div
      className={cn(
        "blog-list-items grid grid-cols-1 gap-4 sm:grid-cols-2 lg:gap-8 2xl:grid-cols-3",
        className,
      )}
    >
      {results.map((blog, index) => {
        const delay = (index + 1) * 200;
        return (
          <BlogCard
            locale={locale}
            blog={blog}
            extraClasses={`blog-teaser--overview animate-fadeInUp animate-delay-[${delay}]`}
            key={blog.id}
            i18n={{
              read_more: t(
                "pages.drupal_page.blog_overview_page.blog_list.read_more",
              ),
            }}
          />
        );
      })}
    </div>
  );
};
